import { LAYOUTS, POSITION, } from "@voltmoney/types";
import { Dimensions } from "react-native";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StepperTypeTokens, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { ACTION, } from "./types";
import { goNext, onBack, onSave, onShare, onSkip } from "./action";
import SharedPropsService from "../../SharedPropsService";
import { partnerApi } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import moment from "moment";
import { getScreenType } from "../../configs/platfom-utils";
export const template = (screenType, isDataUpdated, camsDate, camsAmount, camsPortfolio, karvyDate, karvyAmount, karvyPortfolio, filtered_stepper, unlockedAmont, stepResponseObject) => {
    const _generateDSCAMS = camsAmount
        ? {
            operationalStickyStackCAMS: {
                body: {
                    widgetItems: [
                        {
                            id: "operationalStackCAMS",
                            type: WIDGET.STACK,
                        },
                    ],
                },
            },
        }
        : {};
    const _generateDSKARVY = karvyAmount
        ? {
            operationalStickyStackKARVY: {
                body: {
                    widgetItems: [
                        {
                            id: "operationalStackKARVY",
                            type: WIDGET.STACK,
                        },
                    ],
                },
            },
        }
        : {};
    return {
        layout: {
            id: ROUTE.DISTRIBUTOR_PORTFOLIO,
            type: LAYOUTS.LIST,
            widgets: [
                {
                    id: "header",
                    type: WIDGET.HEADER,
                    position: POSITION.ABSOLUTE_TOP,
                },
                { id: "space0", type: WIDGET.SPACE },
                { id: "space1", type: WIDGET.SPACE },
                ...(`${camsAmount}` !== '0'
                    ? [
                        { id: "operationalStackCAMS", type: WIDGET.STACK }
                    ]
                    : [
                        { id: "camsStack", type: WIDGET.STACK },
                    ]),
                { id: "midDivider", type: WIDGET.DIVIDER },
                ...(`${karvyAmount}` !== '0' ?
                    [
                        { id: "operationalStackKARVY", type: WIDGET.STACK }
                    ] : [
                    { id: "karvyStack", type: WIDGET.STACK },
                ]),
                { id: "karvySpace", type: WIDGET.SPACE },
                // { id: "karvyDivider", type: WIDGET.DIVIDER },
                {
                    id: "continue",
                    type: WIDGET.BUTTON,
                    position: POSITION.ABSOLUTE_BOTTOM,
                },
                { id: "btnSpace", type: WIDGET.SPACE },
                ...(`${isDataUpdated}` === ''
                    ? [{
                            id: "skip",
                            type: WIDGET.BUTTON,
                            position: POSITION.ABSOLUTE_BOTTOM,
                        }] : [{}]),
            ],
        },
        datastore: {
            header: {
                isBackButton: true,
                type: HeaderTypeTokens.verification,
                leftCta: "Share",
                trailIcon: "Share",
                stepperProps: {
                    data: filtered_stepper,
                    type: StepperTypeTokens.HORIZONTAL,
                },
                title: "Create new application",
                action: {
                    type: ACTION.GO_BACK,
                    routeId: ROUTE.DISTRIBUTOR_PORTFOLIO,
                    payload: {},
                },
                leftTitle: {
                    label: `${screenType}` === "extra_small" ? "Share link" : "Copy link",
                    fontFamily: FontFamilyTokens.Inter,
                    fontSize: FontSizeTokens.SM,
                    color: ColorTokens.Primary_100,
                    lineHeight: 24,
                },
                leftAction: {
                    type: ACTION.SHARE,
                    routeId: ROUTE.DISTRIBUTOR_PORTFOLIO,
                    payload: {},
                }
            },
            space0: { size: SizeTypeTokens.SM },
            space1: { size: SizeTypeTokens.MD },
            camsStack: {
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.flexStart,
                widgetItems: [
                    { id: "textStack", type: WIDGET.STACK },
                    { id: "btnStack", type: WIDGET.STACK }
                ],
            },
            textStack: {
                type: StackType.column,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.flexStart,
                widgetItems: [
                    { id: "textItems", type: WIDGET.TEXT },
                    { id: "textSpace", type: WIDGET.SPACE },
                    { id: "subTextItems", type: WIDGET.TEXT }
                ],
            },
            textItems: {
                label: "Fetch from CAMS",
                fontSize: FontSizeTokens.MD,
                fontWeight: '600',
                color: ColorTokens.Grey_Night,
                lineHeight: 24,
                fontFamily: FontFamilyTokens.Inter
            },
            textSpace: {
                size: SizeTypeTokens.SM
            },
            subTextItems: {
                label: "We need OTP authentication in the next screen",
                fontSize: FontSizeTokens.XS,
                fontWeight: '400',
                color: ColorTokens.Grey_Charcoal,
                lineHeight: 18,
                fontFamily: FontFamilyTokens.Inter
            },
            btnStack: {
                type: StackType.column,
                alignItems: StackAlignItems.flexEnd,
                justifyContent: StackJustifyContent.flexEnd,
                widgetItems: [
                    { id: "btnItems", type: WIDGET.BUTTON },
                ],
            },
            btnItems: {
                label: "Fetch",
                type: ButtonTypeTokens.MediumSoftFilled,
                labelColor: ColorTokens.Primary_100,
                width: ButtonWidthTypeToken.CONTENT,
                action: {
                    type: ACTION.GO_OPERATIONAL,
                    routeId: ROUTE.DISTRIBUTOR_PORTFOLIO,
                    payload: {
                        value: "CAMS"
                    },
                },
            },
            midDivider: {
                size: DividerSizeTokens.SM,
                color: ColorTokens.Grey_Milk_1,
                margin: {
                    vertical: SizeTypeTokens.XL,
                    horizontal: SizeTypeTokens.XL,
                },
            },
            karvyStack: {
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.flexStart,
                widgetItems: [
                    { id: "textKarvyStack", type: WIDGET.STACK },
                    { id: "btnKarvyStack", type: WIDGET.STACK }
                ],
            },
            textKarvyStack: {
                type: StackType.column,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.flexStart,
                widgetItems: [
                    { id: "textKarvyItems", type: WIDGET.TEXT },
                    { id: "textkarvySpace", type: WIDGET.SPACE },
                    { id: "subTextKarvyItems", type: WIDGET.TEXT }
                ],
            },
            textKarvyItems: {
                label: "Fetch from Karvy",
                fontSize: FontSizeTokens.MD,
                fontWeight: '600',
                color: ColorTokens.Grey_Night,
                lineHeight: 24,
                fontFamily: FontFamilyTokens.Inter
            },
            textkarvySpace: {
                size: SizeTypeTokens.SM
            },
            subTextKarvyItems: {
                label: "We need OTP authentication in the next screen",
                fontSize: FontSizeTokens.XS,
                fontWeight: '400',
                color: ColorTokens.Grey_Charcoal,
                lineHeight: 18,
                fontFamily: FontFamilyTokens.Inter
            },
            btnKarvyStack: {
                type: StackType.column,
                alignItems: StackAlignItems.flexEnd,
                justifyContent: StackJustifyContent.flexEnd,
                widgetItems: [
                    { id: "btnKarvyItems", type: WIDGET.BUTTON },
                ],
            },
            btnKarvyItems: {
                label: "Fetch",
                type: ButtonTypeTokens.MediumSoftFilled,
                labelColor: ColorTokens.Primary_100,
                width: ButtonWidthTypeToken.CONTENT,
                action: {
                    type: ACTION.GO_OPERATIONAL,
                    routeId: ROUTE.DISTRIBUTOR_PORTFOLIO,
                    payload: {
                        value: "KARVY"
                    },
                },
            },
            karvySpace: {
                size: SizeTypeTokens.SM
            },
            karvyDivider: {
                size: DividerSizeTokens.SM,
                color: ColorTokens.Grey_Milk_1,
                margin: {
                    vertical: SizeTypeTokens.XL,
                    horizontal: SizeTypeTokens.XL,
                },
            },
            ..._generateDSCAMS,
            operationalStackCAMS: {
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.flexStart,
                widgetItems: [
                    { id: "operationalHeadCAMS", type: WIDGET.STACK },
                    { id: "operationalBtnCAMS", type: WIDGET.STACK }
                ],
            },
            operationalHeadCAMS: {
                type: StackType.column,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.flexStart,
                widgetItems: [
                    { id: "headItemsCAMS", type: WIDGET.TEXT },
                    { id: "headSpaceCAMS", type: WIDGET.SPACE },
                    { id: "dateItemsCAMS", type: WIDGET.TEXT },
                    { id: "portfolioItemsCAMS", type: WIDGET.TEXT },
                    // { id: "totalItems", type: WIDGET.TEXT },
                    // { id: "creditLimitItems", type: WIDGET.TEXT },
                    { id: "availableLimitItemsCAMS", type: WIDGET.TEXT },
                    // { id: "limitSpace", type: WIDGET.SPACE },
                    //{ id: "viewPortfolio", type: WIDGET.STACK },
                ],
            },
            headItemsCAMS: {
                label: `Fetch from CAMS`,
                fontSize: FontSizeTokens.MD,
                fontWeight: '600',
                color: ColorTokens.Grey_Night,
                lineHeight: 24,
                fontFamily: FontFamilyTokens.Inter
            },
            headSpaceCAMS: {
                size: SizeTypeTokens.SM
            },
            dateItemsCAMS: {
                label: "Last fetched on " + `${moment.unix(Number(camsDate) / 1000).format("MMMM D")}`,
                fontSize: FontSizeTokens.XS,
                fontWeight: '400',
                color: ColorTokens.Grey_Charcoal,
                lineHeight: 18,
                fontFamily: FontFamilyTokens.Inter
            },
            portfolioItemsCAMS: {
                label: "Portfolio Value: Rs. " + `${camsPortfolio}`,
                fontSize: FontSizeTokens.XS,
                fontWeight: '400',
                color: ColorTokens.Grey_Charcoal,
                lineHeight: 18,
                fontFamily: FontFamilyTokens.Inter
            },
            totalItemsCAMS: {
                label: "",
                fontSize: FontSizeTokens.XS,
                fontWeight: '400',
                color: ColorTokens.Grey_Charcoal,
                lineHeight: 18,
                fontFamily: FontFamilyTokens.Inter
            },
            creditLimitItemsCAMS: {
                label: "Credit limit available: Rs. 20,000",
                fontSize: FontSizeTokens.XS,
                fontWeight: '400',
                color: ColorTokens.Grey_Charcoal,
                lineHeight: 18,
                fontFamily: FontFamilyTokens.Inter
            },
            availableLimitItemsCAMS: {
                label: `Available limit: Rs. ${camsAmount}`,
                fontSize: FontSizeTokens.XS,
                fontWeight: '400',
                color: ColorTokens.Grey_Charcoal,
                lineHeight: 18,
                fontFamily: FontFamilyTokens.Inter
            },
            limitSpaceCAMS: {
                size: SizeTypeTokens.SM
            },
            viewPortfolioCAMS: {
                type: StackType.column,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.flexStart,
                widgetItems: [
                    { id: "protfolioBtnItemsCAMS", type: WIDGET.TEXT },
                ],
                action: {
                    type: ACTION.ON_SAVE,
                    routeId: ROUTE.DISTRIBUTOR_PORTFOLIO,
                    payload: {},
                },
            },
            protfolioBtnItemsCAMS: {
                label: "View Portfolio",
                fontSize: FontSizeTokens.XS,
                fontWeight: '500',
                color: ColorTokens.Primary_100,
                lineHeight: 18,
                fontFamily: FontFamilyTokens.Inter
            },
            operationalBtnCAMS: {
                type: StackType.column,
                alignItems: StackAlignItems.flexEnd,
                justifyContent: StackJustifyContent.flexEnd,
                widgetItems: [
                    { id: "operationalBtnItemsCAMS", type: WIDGET.BUTTON },
                ],
            },
            operationalBtnItemsCAMS: {
                label: "Fetch again",
                type: ButtonTypeTokens.MediumSoftFilled,
                labelColor: ColorTokens.Primary_100,
                width: ButtonWidthTypeToken.CONTENT,
                action: {
                    type: ACTION.GO_OPERATIONAL,
                    routeId: ROUTE.DISTRIBUTOR_PORTFOLIO,
                    payload: {
                        value: "CAMS"
                    },
                },
            },
            ..._generateDSKARVY,
            operationalStackKARVY: {
                type: StackType.row,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.flexStart,
                widgetItems: [
                    { id: "operationalHeadKARVY", type: WIDGET.STACK },
                    { id: "operationalBtnKARVY", type: WIDGET.STACK }
                ],
            },
            operationalHeadKARVY: {
                type: StackType.column,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.flexStart,
                widgetItems: [
                    { id: "headItemsKARVY", type: WIDGET.TEXT },
                    { id: "headSpaceKARVY", type: WIDGET.SPACE },
                    { id: "dateItemsKARVY", type: WIDGET.TEXT },
                    { id: "portfolioItemsKARVY", type: WIDGET.TEXT },
                    // { id: "totalItems", type: WIDGET.TEXT },
                    // { id: "creditLimitItems", type: WIDGET.TEXT },
                    { id: "availableLimitItemsKARVY", type: WIDGET.TEXT },
                    // { id: "limitSpace", type: WIDGET.SPACE },
                    //{ id: "viewPortfolio", type: WIDGET.STACK },
                ],
            },
            headItemsKARVY: {
                label: `Fetch from KARVY`,
                fontSize: FontSizeTokens.MD,
                fontWeight: '600',
                color: ColorTokens.Grey_Night,
                lineHeight: 24,
                fontFamily: FontFamilyTokens.Inter
            },
            headSpaceKARVY: {
                size: SizeTypeTokens.SM
            },
            dateItemsKARVY: {
                label: "Last fetched on " + `${moment.unix(Number(karvyDate) / 1000).format("MMMM D")}`,
                fontSize: FontSizeTokens.XS,
                fontWeight: '400',
                color: ColorTokens.Grey_Charcoal,
                lineHeight: 18,
                fontFamily: FontFamilyTokens.Inter
            },
            portfolioItemsKARVY: {
                label: "Portfolio Value: Rs. " + `${karvyPortfolio}`,
                fontSize: FontSizeTokens.XS,
                fontWeight: '400',
                color: ColorTokens.Grey_Charcoal,
                lineHeight: 18,
                fontFamily: FontFamilyTokens.Inter
            },
            totalItemsKARVY: {
                label: "",
                fontSize: FontSizeTokens.XS,
                fontWeight: '400',
                color: ColorTokens.Grey_Charcoal,
                lineHeight: 18,
                fontFamily: FontFamilyTokens.Inter
            },
            creditLimitItemsKARVY: {
                label: "Credit limit available: Rs. 20,000",
                fontSize: FontSizeTokens.XS,
                fontWeight: '400',
                color: ColorTokens.Grey_Charcoal,
                lineHeight: 18,
                fontFamily: FontFamilyTokens.Inter
            },
            availableLimitItemsKARVY: {
                label: `Available limit: Rs. ${karvyAmount}`,
                fontSize: FontSizeTokens.XS,
                fontWeight: '400',
                color: ColorTokens.Grey_Charcoal,
                lineHeight: 18,
                fontFamily: FontFamilyTokens.Inter
            },
            limitSpaceKARVY: {
                size: SizeTypeTokens.SM
            },
            viewPortfolioKARVY: {
                type: StackType.column,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.flexStart,
                widgetItems: [
                    { id: "protfolioBtnItemsKARVY", type: WIDGET.TEXT },
                ],
                action: {
                    type: ACTION.ON_SAVE,
                    routeId: ROUTE.DISTRIBUTOR_PORTFOLIO,
                    payload: {},
                },
            },
            protfolioBtnItemsKARVY: {
                label: "View Portfolio",
                fontSize: FontSizeTokens.XS,
                fontWeight: '500',
                color: ColorTokens.Primary_100,
                lineHeight: 18,
                fontFamily: FontFamilyTokens.Inter
            },
            operationalBtnKARVY: {
                type: StackType.column,
                alignItems: StackAlignItems.flexEnd,
                justifyContent: StackJustifyContent.flexEnd,
                widgetItems: [
                    { id: "operationalBtnItemsKARVY", type: WIDGET.BUTTON },
                ],
            },
            operationalBtnItemsKARVY: {
                label: "Fetch again",
                type: ButtonTypeTokens.MediumSoftFilled,
                labelColor: ColorTokens.Primary_100,
                width: ButtonWidthTypeToken.CONTENT,
                action: {
                    type: ACTION.GO_OPERATIONAL,
                    routeId: ROUTE.DISTRIBUTOR_PORTFOLIO,
                    payload: {
                        value: "KARVY"
                    },
                },
            },
            continue: {
                label: "Save & Continue",
                type: `${camsAmount}` || `${karvyAmount}` ? ButtonTypeTokens.LargeFilled : ButtonTypeTokens.LargeOutline,
                width: ButtonWidthTypeToken.FULL,
                action: {
                    type: ACTION.ON_SAVE,
                    routeId: ROUTE.DISTRIBUTOR_PORTFOLIO,
                    payload: {
                        value: stepResponseObject
                    },
                },
            },
            btnSpace: {
                size: SizeTypeTokens.MD
            },
            skip: {
                label: "Skip for now",
                type: ButtonTypeTokens.LargeGhost,
                width: ButtonWidthTypeToken.FULL,
                action: {
                    type: ACTION.ON_SKIP,
                    routeId: ROUTE.DISTRIBUTOR_PORTFOLIO,
                    payload: {},
                },
            },
        },
    };
};
export const distributorPortfolioMF = {
    onLoad: async ({ network }, {}) => {
        const screenType = getScreenType(Dimensions.get("window").width);
        const applicationid = await SharedPropsService.getApplicationId();
        const pledgeLimitResponse = await network.get(`${partnerApi.pledgeLimit}${applicationid}`, { headers: await getAppHeader() });
        let data1 = [];
        var stepper_datas = [];
        Object.keys(pledgeLimitResponse.data.partnerViewStepperMap).map(key => {
            const value = pledgeLimitResponse.data.partnerViewStepperMap[key];
            const stepData = new Object();
            if (value.isEditable === true) {
                stepData.title = value.verticalDisplayName;
                stepData.subTitle = value.verticalDescription;
                stepData.id = value.order;
                stepData.horizontalTitle = value.horizontalDisplayName;
                stepData.status = value.status;
                data1.push(stepData);
            }
        });
        stepper_datas = data1.sort(function (a, b) {
            return a.id - b.id;
        });
        let filtered_stepper = [];
        // let stepper_data = await SharedPropsService.getStepperData();
        stepper_datas.forEach((item, index) => {
            if (item.horizontalTitle === "Fetch Portfolio") {
                item.status = "IN_PROGRESS";
            }
            if (item.horizontalTitle === "Select Portfolio") {
                item.status = "NOT_STARTED";
            }
            filtered_stepper.push(item);
        });
        console.log(filtered_stepper);
        await SharedPropsService.setStepperData(stepper_datas);
        // await SharedPropsService.setStepperData(filtered_stepper);
        let unlockedAmont = 0;
        let isDataUpdated = "";
        let camsDate;
        let camsPortfolio = 0;
        let camsAmount = 0;
        let karvyDate;
        let karvyPortfolio = 0;
        let karvyAmount = 0;
        const availableCreditAmount = pledgeLimitResponse.data.stepResponseObject.availableCreditAmount || 0;
        const availableCAS = pledgeLimitResponse.data.stepResponseObject.availableCAS || [];
        const stepResponseObject = pledgeLimitResponse.data.stepResponseObject;
        unlockedAmont = pledgeLimitResponse.data.stepResponseObject.availableCreditAmount;
        const conditionData = pledgeLimitResponse.data.stepResponseObject.repositoryAssetMetadataMap;
        let conditionDataKAMS = pledgeLimitResponse.data.stepResponseObject.repositoryAssetMetadataMap.CAMS;
        let conditionDataKARVY = pledgeLimitResponse.data.stepResponseObject.repositoryAssetMetadataMap.KARVY;
        if (conditionDataKAMS.availableCreditAmount !== 0) {
            camsDate = pledgeLimitResponse.data.stepResponseObject.repositoryAssetMetadataMap.CAMS.casFetchDate;
            camsDate = new Date(camsDate * 1000);
            camsPortfolio = pledgeLimitResponse.data.stepResponseObject.repositoryAssetMetadataMap.CAMS.availablePortfolioAmount;
            camsAmount = pledgeLimitResponse.data.stepResponseObject.repositoryAssetMetadataMap.CAMS.availableCreditAmount;
            isDataUpdated = "Data Exist";
        }
        if (conditionDataKARVY.availableCreditAmount !== 0) {
            karvyDate = pledgeLimitResponse.data.stepResponseObject.repositoryAssetMetadataMap.KARVY.casFetchDate;
            karvyDate = new Date(karvyDate * 1000);
            karvyPortfolio = pledgeLimitResponse.data.stepResponseObject.repositoryAssetMetadataMap.KARVY.availablePortfolioAmount;
            karvyAmount = pledgeLimitResponse.data.stepResponseObject.repositoryAssetMetadataMap.KARVY.availableCreditAmount;
            isDataUpdated = "Data Exist";
        }
        const applictaionId = await SharedPropsService.getApplicationId();
        let camsFetches = {};
        return Promise.resolve(template(screenType, isDataUpdated, camsDate, camsAmount, camsPortfolio, karvyDate, karvyAmount, karvyPortfolio, filtered_stepper, unlockedAmont, stepResponseObject));
    },
    actions: {
        [ACTION.ON_SAVE]: onSave,
        [ACTION.ON_SKIP]: onSkip,
        [ACTION.GO_BACK]: onBack,
        [ACTION.SHARE]: onShare,
        [ACTION.GO_OPERATIONAL]: goNext,
    },
    clearPrevious: true,
};
